import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import useStyles from "../../../../styles";

import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { sanitizeInput } from "../../../../Utils/validationUtils";
import OtpPopup from "../OtpPopup/OtpPopup";

function EditAuthUserForm() {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const { rowId } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  const classes = useStyles();

  // Dynamic OTP state
  const [otpOpen, setOtpOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const triggerOtp = (action) => {
    setPendingAction(() => action);
    setOtpOpen(true);
  };

  const handleClose = () => {
    navigate("/admin/authuser");
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
          { headers: { Authorization: `Bearer ${decryptedToken}` } }
        );
        setSubjects(response.data.subjects || []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, [decryptedToken]);

  const fetchDataFromAPI = async (rowId, otp) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/${rowId}?otp=${otp}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.auth_user;

        setName(data.name);
        setEmail(data.email);
        setMobileNumber(data.phone);
        setSelectedSubjects(data.subject_ids ? data.subject_ids.map((s) => s.id) : []);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (rowId) {
      triggerOtp((otp) => fetchDataFromAPI(rowId, otp));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId]);

  const handleFormSubmit = () => {
    if (!name.trim()) {
      toast.warn("Please enter a name.");
      return;
    }

    const data = {
      auth_user: {
        name: name,
        email: email,
        phone: mobileNumber,
        id: rowId,
        subject_ids: selectedSubjects,
      },
    };

    triggerOtp((otp) => {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/update`,
          { ...data, otp: otp },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        )
        .then((response) => {
          setTimeout(() => {
            navigate("/admin/authuser");
          }, 2000);
          toast.success("Auth User updated successfully");
        })
        .catch((error) => {
          console.error("Error changed Course status:", error);
          toast.error(error.response?.data?.message || "Auth User is not updated");
          throw error;
        });
    });
  };

  return (
    <>
      <ToastContainer />

      <OtpPopup
        open={otpOpen}
        onClose={() => {
          setOtpOpen(false);
          setPendingAction(null);
        }}
        onVerified={async (data, otp) => {
          if (pendingAction) {
            try {
              await pendingAction(otp);
              setOtpOpen(false);
              setPendingAction(null);
            } catch (error) {
              // Action failed (e.g. invalid OTP), keep popup open
              // OtpPopup will handle the loading state and toast
            }
          }
        }}
        sendOtpApi={`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/otp/send`}
        payload={{}}
      />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Edit Auth User Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setName(sanitizeInput(e.target.value, "textInput"))}
                  value={name}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                  <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Email <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setEmail(sanitizeInput(e.target.value, "textInput"))}
                  value={email}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                />

              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                 <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Phone No. <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) =>
                    setMobileNumber(
                      e.target.value.replace(/[^0-9]/g, "").slice(0, 10)
                    )
                  }
                  value={mobileNumber}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                  inputProps={{ maxLength: 10 }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="subject-autocomplete"
                  disableClearable
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name || ""}
                  value={subjects.filter((s) =>
                    selectedSubjects.includes(s.id)
                  )}
                  onChange={(event, newValue) => {
                    setSelectedSubjects(newValue.map((v) => v.id));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Subjects"
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>
          </div>
          <div className={`${classes.dflex} ${classes.justifyflexend}`}>
            <Button
              onClick={handleClose}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditAuthUserForm;
